import { redirect } from 'react-router-dom';
import { getEulaService } from 'services/eula';
import { isAuthed } from 'utils/common/session';

export const eulaQueryKeys = {
  all: ['eula'],
  detail: (userId) => [...eulaQueryKeys.all, 'detail', parseInt(userId)],
};

export const prefetchEulaQuery = async (queryClient, userId) => {
  await queryClient.prefetchQuery({
    queryKey: eulaQueryKeys.detail(userId),
    queryFn: async () => {
      const response = await getEulaService();
      if (!response?.isSuccess) {
        throw new Error('Failed to fetch EULA');
      }
      return response.data;
    },
  });
};

export const getEulaFromCache = (queryClient, userId) => {
  return queryClient.getQueryData(eulaQueryKeys.detail(userId));
};

export const ensureEulaData = async (queryClient, userId) => {
  // Early return if not authenticated or no userId
  if (!isAuthed() || !userId) {
    throw new Error('User not authenticated or userId missing');
  }

  try {
    const eulaData = await queryClient.ensureQueryData({
      queryKey: eulaQueryKeys.detail(userId),
      queryFn: async () => {
        const response = await getEulaService();
        return response?.data;
      },
    });

    return eulaData;
  } catch (error) {
    throw error;
  }
};

export const validateEulaFlow = async ({ queryClient, userId, returnUrl }) => {
  try {
    const eulaData = await ensureEulaData(queryClient, userId);
    // No active EULA for this user means there is nothing to accept
    if (!eulaData) return;

    if (!eulaData.isAccepted) {
      throw redirect(`/eula?returnUrl=${encodeURIComponent(returnUrl)}`);
    }
  } catch (error) {
    if (error?.status === 302 || error instanceof Response) {
      throw error;
    }
  }
};
